/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MarkerTypeFromJSON, MarkerTypeToJSON, } from './MarkerType';
/**
 * Check if a given object implements the UserIncidentFootageMarkerDto interface.
 */
export function instanceOfUserIncidentFootageMarkerDto(value) {
    let isInstance = true;
    return isInstance;
}
export function UserIncidentFootageMarkerDtoFromJSON(json) {
    return UserIncidentFootageMarkerDtoFromJSONTyped(json, false);
}
export function UserIncidentFootageMarkerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userIncidentFootageId': !exists(json, 'userIncidentFootageId') ? undefined : json['userIncidentFootageId'],
        'offsetMs': !exists(json, 'offsetMs') ? undefined : json['offsetMs'],
        'markerType': !exists(json, 'markerType') ? undefined : MarkerTypeFromJSON(json['markerType']),
    };
}
export function UserIncidentFootageMarkerDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'userIncidentFootageId': value.userIncidentFootageId,
        'offsetMs': value.offsetMs,
        'markerType': MarkerTypeToJSON(value.markerType),
    };
}
